import { Box, Checkbox, FormGroup, FormSection, Select, Text } from '@ksyos/design-system';
import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { useProcessActivityEditContext } from '@frontend/utils';
import { TextAreaFormGroup } from '../../../processActivityFormGroupFields';
import { weeksOptions } from '../../osasConsult/components/weeksOptions';

export function PolicyFormSection() {
    const { data, onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <FormSection title="Beleid">
            <TextAreaFormGroup
                fieldKey="policy"
                label="Beleid"
            />
            <FormGroup label="Vervolgevaluatie bij OSAS consulent">
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    gap={2}
                    mt={1}
                    size="sm"
                >
                    <Checkbox
                        checked={!!data.followUpEvaluationWeeks}
                        label={
                            <Text
                                size="sm"
                                whiteSpace="nowrap"
                            >
                                Ja, na
                            </Text>
                        }
                        onChange={async (e) => {
                            onChange(
                                { followUpEvaluationWeeks: e.target.checked ? 3 : null },
                                'followUpEvaluationWeeks'
                            );
                        }}
                    />

                    <Box width={'80px'}>
                        <Select
                            onChange={async (option) => {
                                onChange(
                                    { followUpEvaluationWeeks: parseInt(option?.value ?? '') ?? null },
                                    'followUpEvaluationWeeks'
                                );
                            }}
                            options={weeksOptions}
                            value={{
                                label: data.followUpEvaluationWeeks?.toString() ?? '',
                                value: data.followUpEvaluationWeeks?.toString() ?? '',
                            }}
                        />
                    </Box>
                    <Text size="sm">weken</Text>
                </Box>
            </FormGroup>
        </FormSection>
    );
}
